/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, count: NonNullable<unknown> }} Workout_Sets_In_ExercisesInputs */

const en_us2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} in 1 exercise`);
	return /** @type {LocalizedString} */ (`${i?.sets} in ${i?.count} exercises`)
	
};

const pt_br2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} em 1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.sets} em ${i?.count} exercícios`)
	
};

const es_419_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} en 1 ejercicio`);
	return /** @type {LocalizedString} */ (`${i?.sets} en ${i?.count} ejercicios`)
	
};

const pt_pt2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} em 1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.sets} em ${i?.count} exercícios`)
	
};

const fr_fr2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} sur 1 exercice`);
	return /** @type {LocalizedString} */ (`${i?.sets} sur ${i?.count} exercices`)
	
};

const de_de2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} in 1 Übung`);
	return /** @type {LocalizedString} */ (`${i?.sets} in ${i?.count} Übungen`)
	
};

const it_it2_workout_sets_in_exercises = /** @type {(inputs: Workout_Sets_In_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.sets} in 1 esercizio`);
	return /** @type {LocalizedString} */ (`${i?.sets} in ${i?.count} esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "{sets} in 1 exercise" |
* | * | "{sets} in {count} exercises" |
*
* @param {Workout_Sets_In_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sets_in_exercises = /** @type {((inputs: Workout_Sets_In_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sets_In_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sets_in_exercises(inputs)
	if (locale === "es-419") return es_419_workout_sets_in_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sets_in_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sets_in_exercises(inputs)
	if (locale === "de-DE") return de_de2_workout_sets_in_exercises(inputs)
	if (locale === "it-IT") return it_it2_workout_sets_in_exercises(inputs)
	return en_us2_workout_sets_in_exercises(inputs)
});
export { workout_sets_in_exercises as "workout.sets_in_exercises" }